import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import VulnerabilitiesFiltersDialog from "./VulnerabilitiesFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";
import { displayMultiSelect } from "../Utility/ChipDisplay";

interface IVulnerabilitiesFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function VulnerabilitiesFilters({ callTableViewModel, setCallTableViewModel }: IVulnerabilitiesFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                'Vulnerabilities'
            }
            {
                displayMultiSelect(callTableViewModel.filters.vulnerabilitiesFilters.vulnerabilityCategory, 'Categories')
            }
            {
                displayMultiSelect(callTableViewModel.filters.vulnerabilitiesFilters.vulnerability, '')
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <VulnerabilitiesFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}